export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8989.a574912c.jpg";